@if (deviceSize$ | async; as deviceSize) {
  <mat-dialog-content class="no-scrollbar" [ngClass]="{ mobile: deviceSize.isMobile }">
    <div class="position-relative p-large">
      <button class="close-icon" (click)="close()">
        <img src="assets/glyphs/new-design/partner-app/close.svg" alt="close" />
      </button>
      <p class="f-24 fw-heavy text-center mt-0 mb-x-large">Download the Prudent Plus App</p>
      <div class="custom-row w-100 flex-no-wrap">
        <div class="w-50 custom-column align-items-center">
          <img src="assets/glyphs/new-design/download-app/google-qr-code.png" alt="Google QR code" width="130" />
          <img
            src="assets/glyphs/new-design/download-app/google-play.svg"
            alt="Google play"
            width="160"
            class="store-icon"
          />
        </div>
        <div class="w-50 custom-column align-items-center">
          <img src="assets/glyphs/new-design/download-app/apple-qr-code.png" alt="Apple QR code" width="130" />
          <img
            src="assets/glyphs/new-design/download-app/app-store.svg"
            alt="App store"
            width="160"
            class="store-icon"
          />
        </div>
      </div>
    </div>
  </mat-dialog-content>
}
